import * as React from "react"

function SvgCheckBoxCheckedV2(props) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M22.1667 24.5H5.83333C4.55 24.5 3.5 23.45 3.5 22.1667V5.83333C3.5 4.55 4.55 3.5 5.83333 3.5H22.1667C23.45 3.5 24.5 4.55 24.5 5.83333V22.1667C24.5 23.45 23.45 24.5 22.1667 24.5Z"
        fill="#004BB0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7722 9.57055C21.0759 9.88598 21.0759 10.3974 20.7722 10.7128L12.2166 19.5974C11.9129 19.9128 11.4204 19.9128 11.1167 19.5974L7.22781 15.559C6.92406 15.2435 6.92406 14.7321 7.22781 14.4167C7.53155 14.1013 8.02401 14.1013 8.32775 14.4167L11.6667 17.884L19.6723 9.57055C19.976 9.25513 20.4685 9.25513 20.7722 9.57055Z"
        fill="white"
      />
    </svg>
  )
}

export default SvgCheckBoxCheckedV2
